module.exports = __webpack_public_path__ + "img/bash-stencil.6fd3f428.svg";